import { faArrowsMaximize } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { packageIsScorm, PackageType } from "features/Shared/ContentData/PackageType";
import { useModal } from "components/Modal/context/ModalContext";
import { ModalButtons } from "components/Modal/ModalButtons";
import { useState } from "react";
import "./PlayerMedia.scss";

const PlayerMedia = ({ data, mediaRef, title, handleMediaLoaded, calculatedPlayerHeight, previewMode = false }) => {
	const { openModal } = useModal();
	const [hideModal, setHideModal] = useState(false);

	const getUri = () => {
		if (!packageIsScorm(data.Type)) {
			return getXapiUri();
		}
		return getScormUri();
	}

	const getScormUri = () => {
		// ucSKILLS 2 passes a height, but this appears to be overriden by the #scorm-frame iframe in the scormframe.html anyway...
		const scormParameters = {
			src: data.Path + data.LaunchPage,
			version: data.ScormData.Version,
			data: data.ScormData.CmiData,
			log: data.ScormData.LogApi
		};

		// Cache-buster: adding a throwaway query parameter in the real URL part before the hash so it is considered a new request.
		const proxy = new URL(data.ScormData.ProxyUri, window.location.origin);
		proxy.searchParams.set("_", `${data.Module?.Id}-${data.Submodule?.Id}`);
		return `${proxy.toString()}#${encodeURIComponent(JSON.stringify(scormParameters))}`;
	}

	const getXapiUri = () => {
		let result = data.Path + data.LaunchPage;
		const actorParam = JSON.stringify({
			"account": {
				"homePage": "https://iteluk.com",
				"name": previewMode ? "PREVIEW" : btoa(data.PathIds)
			}
		});

		// Ensure the entire actor parameter is URI-encoded
		result += "&actor=" + encodeURIComponent(actorParam);
		return result;
	}

	const getUniqueKey = () => `${data.Course?.Id}-${data.Module?.Id}-${data.Submodule?.Id}`;

	const processFullScreenRequestError = (error) => {
		console.error(`An error occurred when trying to enter fullscreen mode: ${error.message}`);
		openModal(null, "Sorry, full screen not available in your browser.", ModalButtons.Ok);
		setHideModal(true);
	};

	const handleMaximizeButton = () => {
		const frame = mediaRef && mediaRef.current;
		if (frame.requestFullscreen) {
			frame.requestFullscreen().catch((error) => {
				processFullScreenRequestError(error);
			});
		}
		else if (frame.mozRequestFullScreen) {
			/* Firefox < 64 */
			frame.mozRequestFullScreen().catch((error) => {
				processFullScreenRequestError(error);
			});
		}
		else if (frame.webkitRequestFullscreen) {
			/* Chrome < 68, Safari and Opera */
			frame.webkitRequestFullscreen().catch((error) => {
				processFullScreenRequestError(error);
			});
		}
	};

	const renderMaximizeIcon = () => {
		if (hideModal || data.Type === PackageType.xAPI) {
			return null;
		}
		const frame = mediaRef && mediaRef.current;
		if (frame && frame.contentWindow) {
			if (frame.requestFullscreen || frame.mozRequestFullScreen || frame.webkitRequestFullscreen) {
				return (
					<div className="player-media-maximize-button" onClick={handleMaximizeButton} title="View full screen">
						<FontAwesomeIcon icon={faArrowsMaximize} />
					</div>
				);
			}
		}
		return null;
	};

	return (
		<div className="player-media" style={{ height: calculatedPlayerHeight }}>
			<div className="player-media-container">
				<iframe id="player-content" key={getUniqueKey()} ref={mediaRef} title={title} src={getUri()} onLoad={handleMediaLoaded} allowFullScreen></iframe>
				{renderMaximizeIcon()}
			</div>
		</div>
	);
};

export default PlayerMedia;
